import styled from 'styled-components'

import { TransformProps } from '@application/Interfaces/Icons/types'

const MAP_TRANSFORMS_WITH_DEGREE: Record<TransformProps, number> = {
    left: -180,
    down: -270,
    right: 0,
    up: -90,
}

export const SVG = styled.svg<{ direction: TransformProps }>`
    transform: rotate(${(props) => MAP_TRANSFORMS_WITH_DEGREE[props.direction]}deg);
    transition: transform cubic-bezier(0.4, 0, 0.6, 1) 225ms;
`
